import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-content-page-wrapper',
  templateUrl: './app-content-page-wrapper.component.html',
  styleUrls: ['./app-content-page-wrapper.component.scss']
})
export class AppContentPageWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


/**
 * Component for testing
 *
 * @export
 * @class DummyComponent
 */
@Component({
  selector: 'app-dummy-wrapper',
  template: '<app-app-content-page-wrapper><div id="test"></div></app-app-content-page-wrapper>',

})

export class DummyComponent {

}
